export class MemberDiscountRequest {
    discountValue: string;
    startDate: Date;
    endDate: Date;
    redemptionLimit: string;

    constructor(discountValue: string,
        startDate: Date,
        endDate: Date,
        redemptionLimit: string) {
        this.discountValue = discountValue;
        this.startDate = startDate;
        this.endDate = endDate;
        this.redemptionLimit = redemptionLimit;
        }
}